import React from 'react';
import PropTypes from 'prop-types';
import { Button, CurrencyFormat } from '@lt/components';

const baseCls = 'hotel-price-badge';

const PriceBadge = ({ value, onClick }) => (
  <span className={baseCls}>
    <span className={`${baseCls}__inner`}>
      {!value ? (
        <span className={`${baseCls}__skeleton`}>от __ ___ ₽</span>
      ) : (
        <Button functional className="lt-link" onClick={onClick}>
          от&nbsp;
          <CurrencyFormat value={value} />
        </Button>
      )}
    </span>
  </span>
);

PriceBadge.propTypes = {
  value: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

PriceBadge.defaultProps = {
  value: null,
};

export default PriceBadge;
